<nb-card>
    <nb-card-header>
        <h5>Selecionar Host</h5>
    </nb-card-header>
    <nb-card-body>
        <nb-tabset fullWidth>
            <nb-tab tabTitle="Tênis">
                <div class="tennis-content">
                    <h6 class="section-title">Confederações</h6>
                    <div class="host-list">
                        <div
                            *ngFor="let host of availableHosts.tennis.confederations"
                            class="host-item"
                            [class.selected]="selectedHost === host"
                            (click)="selectHost(host)"
                        >
                            <nb-icon
                                icon="checkmark-circle-2-outline"
                                *ngIf="selectedHost === host"
                                class="check-icon"
                            ></nb-icon>
                            <span class="host-text">{{ host }}</span>
                        </div>
                    </div>
                    <h6 class="section-title">Federações</h6>
                    <div class="host-list">
                        <div
                            *ngFor="let host of availableHosts.tennis.federations"
                            class="host-item"
                            [class.selected]="selectedHost === host"
                            (click)="selectHost(host)"
                        >
                            <nb-icon
                                icon="checkmark-circle-outline"
                                *ngIf="selectedHost === host"
                                class="check-icon"
                            ></nb-icon>
                            <span class="host-text">{{ host }}</span>
                        </div>
                    </div>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Pickleball">
                <div class="host-list">
                    <div
                        *ngFor="let host of availableHosts.pickleball"
                        class="host-item"
                        [class.selected]="selectedHost === host"
                        (click)="selectHost(host)"
                    >
                        <nb-icon
                            icon="checkmark-circle-2-outline"
                            *ngIf="selectedHost === host"
                            class="check-icon"
                        ></nb-icon>
                        <span class="host-text">{{ host }}</span>
                    </div>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Golf">
                <div class="host-list">
                    <div
                        *ngFor="let host of availableHosts.golf"
                        class="host-item"
                        [class.selected]="selectedHost === host"
                        (click)="selectHost(host)"
                    >
                        <nb-icon
                            icon="checkmark-circle-2-outline"
                            *ngIf="selectedHost === host"
                            class="check-icon"
                        ></nb-icon>
                        <span class="host-text">{{ host }}</span>
                    </div>
                </div>
            </nb-tab>
        </nb-tabset>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="basic" (click)="cancel()" class="mr-2">Cancelar</button>
        <button nbButton status="primary" (click)="confirm()" [disabled]="!selectedHost">Confirmar</button>
    </nb-card-footer>
</nb-card>
